import apiUrl from "../../../constants";
import axios from "axios";
import CryptoJS from "crypto-js";
import VueElementLoading from "vue-element-loading";
import Paginate from "vuejs-paginate";
import { BasicSelect } from "vue-search-select";
import download from "downloadjs";
import moment from "moment";
import utils from "../../../utils/validateScanner";

// NTC Mapping Master — upload-only feature (mirrors DockMaster upload flow).
// Only backend endpoint wired today: POST /ntcmappingmaster/upload
// Header row for the sample .csv must stay in sync with the backend parser.
// HUB-8353: Route (Air/Surface) is required — matches odntcmaster.routemode.
// HUB-8xxx: `secondary_ntc` is optional per-row (blank cells clear the
// existing Secondary NTC on that route during upsert).
const NTC_MAPPING_COLUMNS = [
  { key: "scan_location", header: "Scan location", required: true },
  { key: "bag_origin", header: "Bag Origin", required: true },
  { key: "bag_destination_id", header: "Bag destination Id", required: true },
  { key: "bag_destination", header: "Bag destination", required: true },
  { key: "route", header: "Route", required: true },
  { key: "ntc", header: "NTC", required: true },
  { key: "secondary_ntc", header: "Secondary NTC", required: false },
];

const ROUTE_MODE_OPTIONS = [
  { value: "Air", text: "Air" },
  { value: "Surface", text: "Surface" },
];

// HUB-8xxx: fields the operator can change from the Edit modal. Change
// detection is done against the row's original values so we only send the
// fields the operator actually touched — matches the BE contract where an
// omitted field is a no-op and an empty `secondaryNtc` clears the value.
const EDITABLE_SELECT_FIELDS = ["ntc", "destination", "secondaryNtc"];

export default {
  name: "NtcMappingMaster",
  mixins: [utils],
  components: {
    VueElementLoading,
    BasicSelect,
    Paginate,
    download,
  },
  data: function () {
    return {
      hubId: "",
      createdBy: "",
      isLoadingUpload: false,
      failed: [],
      selectedFile: null,
      currentTab: "upload",
      tabs: [
        {
          key: "upload",
          value: "NTC Mapping Upload",
        },
          {
          key: "Manage",
          value: "Add/Manage Mapping",
        },
                {
          key: "history",
          value: "History",
        },
      ],
      ntcColumns: NTC_MAPPING_COLUMNS,
      routeModeOptions: ROUTE_MODE_OPTIONS,
      hublist: [],
      bagOriginOptions: [{ value: "1", text: "ALL" }],
      _hubListLoading: false,
      _hubListLoaded: false,
      manageSearchReady: false,
      hubloader: "",
      isAddingRow: false,
      hubItems: {
        bagOrigin:    { value: "", text: "" },
        scanLocation: { value: "", text: "" },
        destination:  { value: "", text: "" },
        route:        { value: "", text: "" },
        ntc:          { value: "", text: "" },
        secondaryNtc: { value: "", text: "" },
      },
      hubValues: {
        bagOrigin: "",
        scanLocation: "",
        destination: "",
        route: "",
        ntc: "",
        secondaryNtc: "",
      },

      // HUB-8xxx: post-upload counters — surfaced in the success toast and
      // rendered under the upload form (inserted vs updated split).
      lastUploadSummary: null,

      // HUB-8xxx: search/manage state — filters, table rows, pagination.
      isSearching: false,
      mappings: [],
      pageno: 0,
      limit: 10,
      totalRows: 0,
      pageCount: 0,
      searchItems: {
        bagOrigin:    { value: "", text: "" },
        scanLocation: { value: "", text: "" },
        destination:  { value: "", text: "" },
        routeMode:    { value: "", text: "" },
        ntc:          { value: "", text: "" },
        isActive:     { value: "", text: "" },
      },
      searchValues: {
        bagOrigin: "",
        scanLocation: "",
        destination: "",
        routeMode: "",
        ntc: "",
        isActive: "",
      },
      isActiveOptions: [
        { value: "",      text: "All" },
        { value: "true",  text: "Active" }
     
      ],

      // Edit modal state — NTC, destination, secondaryNtc and isActive are
      // editable per BE contract. Change detection against `editOriginal`
      // means only touched fields are sent, so an unchanged Secondary NTC
      // never accidentally re-submits and a cleared Secondary NTC sends "".
      isEditModalShow: false,
      isSavingEdit: false,
      editItems: {
        ntc:          { value: "", text: "" },
        destination:  { value: "", text: "" },
        secondaryNtc: { value: "", text: "" },
      },
      editForm: {
        id: null,
        bagOrigin: "",
        scanLocation: "",
        destination: "",
        ntc: "",
        secondaryNtc: "",
        isActive: true,
      },
      editOriginal: {
        destination: "",
        ntc: "",
        secondaryNtc: "",
      },

      // HUB-8xxx: history tab — paginated list of CSV uploads.
      // Backed by GET /ntcmappingmaster/history (uploadedBy optional).
      isLoadingHistory: false,
      historyRows: [],
      historyPageno: 0,
      historyLimit: 10,
      historyTotalRows: 0,
      historyPageCount: 0,
      historyFilter: {
        uploadedBy: "",
      },

      // HUB-8xxx: audit modal — per-file audit trail backed by
      // GET /ntcmappingmaster/auditHistory. Kept separate from the search /
      // history pagination so each surface pages independently.
      isAuditModalShow: false,
      isLoadingAudit: false,
      auditRows: [],
      auditFileId: null,
      auditFileName: "",
      auditPageno: 0,
      auditLimit: 10,
      auditTotalRows: 0,
      auditPageCount: 0,
    };
  },

  filters: {
    moment(date) {
      if (!date) return "--";
      return moment(date).format("DD-MM-YYYY HH:mm:ss");
    },
  },

  mounted() {
    var userdetailEncrypt = window.localStorage.getItem("userdetail");
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), "Key");
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.createdBy = userdetail[0].email;
    this.hubId = userdetail[0].HubId[0];
  },

  methods: {
    // Batch-load hub options once; avoids N push() reactivity cycles from the
    // mixin and defers the fetch until the Manage tab is first opened.
    getHubList() {
      if (this._hubListLoaded || this._hubListLoading) return;

      this._hubListLoading = true;
      this.hubloader = "Loading Hub...";

      axios({
        method: "POST",
        url: apiUrl.api_url_hubops + "expose/hubservicecenter/dropdwon/list",
        data: {},
        headers: { authorization: "authkey xB84JJ89Hd25" },
      }).then(
        (result) => {
          this.hubloader = "";
          this._hubListLoading = false;
          this._hubListLoaded = true;

          const hubDetails = result.data.ResponseData || [];
          const options = hubDetails.map((h) => ({
            value: h.HubID,
            text: h.HubName + " (" + h.HubID + ")",
          }));

          this.hublist = Object.freeze(options);
          this.bagOriginOptions = Object.freeze([
            { value: "1", text: "ALL" },
            ...options,
          ]);

          if (this.currentTab === "Manage") {
            this.$nextTick(() => {
              this.manageSearchReady = true;
              this.$nextTick(() => {
                this.searchMappings();
              });
            });
          }
        },
        (error) => {
          this.hubloader = "";
          this._hubListLoading = false;
          console.error(error);
        },
      );
    },

    secondFunction(tab) {
      this.currentTab = tab.key;
      if (tab.key === "Manage") {
        this.pageno = 0;
        this.lastUploadSummary = null;

        if (this._hubListLoaded) {
          this.manageSearchReady = true;
          this.searchMappings();
        } else {
          this.manageSearchReady = false;
          this.getHubList();
        }
      }
      if (tab.key === "history") {
        // HUB-8xxx: History tab now shows the global audit trail — reset the
        // audit paginator (not the old file-history one) before fetching.
        this.auditPageno = 0;
        this.getAuditHistory();
        this.lastUploadSummary = null
      }
    },

    selectHub(field, item) {
      this.hubItems[field]  = item;
      this.hubValues[field] = item.text;
    },

    selectRouteMode(field, item) {
      this.hubItems[field] = item || { value: "", text: "" };
      this.hubValues[field] = item ? item.text : "";
    },

    selectSearchFilter(field, item) {
      this.searchItems[field]  = item;
      this.searchValues[field] = item.text;
    },

    // HUB-8xxx: shared handler for every editable basic-select in the Edit
    // modal (NTC, Destination, …). Field name must match a key in
    // `editItems` + `editForm`.
    selectEditField(field, item) {
      this.editItems[field] = item;
      this.editForm[field]  = this.extractHubName(item.text);
    },

    extractHubName(text) {
      return (text || "").split("(")[0].trim();
    },

    // HUB-8xxx: resolve a stored hub name (e.g. "MUM") back to its hublist
    // option so the basic-select shows the pre-selected label. Falls back to
    // the plain name when the hublist hasn't loaded / doesn't contain it.
    matchHubOption(name) {
      const value = name || "";
      const found = this.hublist.find(
        (h) => this.extractHubName(h.text) === value,
      );
      return found
        ? { value: found.value, text: found.text }
        : { value, text: value };
    },

    resetAddForm() {
      Object.keys(this.hubItems).forEach((k) => {
        this.hubItems[k]  = { value: "", text: "" };
        this.hubValues[k] = "";
      });
      this.$validator.reset();
      this.errors.clear();
    },

    // HUB-8xxx: Secondary NTC is optional but, when provided, must resolve to
    // a hub in the hub master AND cannot equal the Primary NTC. The dropdown
    // already restricts to hublist so we only need the equality check here.
    clearAddSecondaryNtc() {
      this.hubItems.secondaryNtc  = { value: "", text: "" };
      this.hubValues.secondaryNtc = "";
    },

    addMappingRow() {
      this.$validator
        .validateAll()
        .then((result) => {
          if (!result) return;

          const primaryNtc   = this.extractHubName(this.hubItems.ntc.text);
          const secondaryNtc = this.extractHubName(this.hubItems.secondaryNtc.text);

          if (secondaryNtc && secondaryNtc === primaryNtc) {
            this.$alertify.error("Secondary NTC cannot be the same hub as NTC.");
            return;
          }

          const route = (this.hubItems.route.text || "").trim();
          if (route !== "Air" && route !== "Surface") {
            this.$alertify.error("Route must be Air or Surface.");
            return;
          }

          this.isAddingRow = true;
          const payload = {
            bagOrigin:    this.extractHubName(this.hubItems.bagOrigin.text),
            scanLocation: this.extractHubName(this.hubItems.scanLocation.text),
            destination:  this.extractHubName(this.hubItems.destination.text),
            route,
            ntc:          primaryNtc,
            // HUB-8xxx: BE accepts empty string ("") for Secondary NTC on
            // addRow — no need to omit the key.
            secondaryNtc: secondaryNtc,
            uploadedBy:   this.createdBy,
            currentHubId: this.hubId,
          };

          axios
            .post(apiUrl.api_url_hubops + "ntcmappingmaster/addRow", payload, {
              headers: { Authorization: "authkey xB84JJ89Hd25" },
            })
            .then(
              (res) => {
                this.isAddingRow = false;
                if (res.data.ResultCode == 100) {
                  this.$alertify.success(res.data.ReturnMessage);
                  this.searchMappings();
                } else {
                  this.$alertify.error(res.data.ReturnMessage);
                }
                this.resetAddForm();
              },
              (err) => {
                console.error(err);
                this.isAddingRow = false;
                this.$alertify.error("Error Occured");
              },
            );
        })
        .catch(() => {
          this.$alertify.error("Error Occured");
        });
    },

    // HUB-8xxx: paginated, filtered search backed by GET /ntcmappingmaster/search.
    // Only the currentHubId+limit+offset are always sent; text filters are
    // optional and are omitted when blank so the BE Joi validator doesn't
    // treat empty strings as required-and-invalid.
    searchMappings() {
      this.isSearching = true;
      const params = {
        currentHubId: this.hubId,
        limit:  this.limit,
        offset: this.pageno * this.limit,
      };

      const bagOrigin    = this.extractHubName(this.searchItems.bagOrigin.text);
      const scanLocation = this.extractHubName(this.searchItems.scanLocation.text);
      const destination  = this.extractHubName(this.searchItems.destination.text);
      const ntc          = this.extractHubName(this.searchItems.ntc.text);

      if (bagOrigin)    params.bagOrigin    = bagOrigin;
      if (scanLocation) params.scanLocation = scanLocation;
      if (destination)  params.destination  = destination;
      if (ntc)          params.ntc          = ntc;
      const routeMode = (this.searchItems.routeMode.text || "").trim();
      if (routeMode) params.routeMode = routeMode;
      if (this.searchItems.isActive.value !== "") {
        params.isActive = this.searchItems.isActive.value === "true";
      }

      axios
        .get(apiUrl.api_url_hubops + "ntcmappingmaster/search", {
          params,
          headers: { Authorization: "authkey xB84JJ89Hd25" },
        })
        .then(
          (res) => {
            this.isSearching = false;
            if (res.data.ResultCode == 100) {
              this.mappings  = res.data.ResponseData || [];
              const pg       = res.data.pagination || {};
              this.totalRows = pg.totalCount || this.mappings.length;
              this.pageCount = pg.totalPages || 0;
            } else if (res.data.ResultCode == 101) {
              this.mappings  = [];
              this.totalRows = 0;
              this.pageCount = 0;
            } else {
              this.$alertify.error(res.data.ReturnMessage);
            }
          },
          (err) => {
            console.error(err);
            this.isSearching = false;
            this.$alertify.error("Error Occured");
          },
        );
    },

    applyFilters() {
      this.pageno = 0;
      this.searchMappings();
    },

    resetFilters() {
      Object.keys(this.searchItems).forEach((k) => {
        this.searchItems[k]  = { value: "", text: "" };
        this.searchValues[k] = "";
      });
      this.pageno = 0;
      this.searchMappings();
    },

    getPaginationData(pageNum) {
      this.pageno = pageNum - 1;
      this.searchMappings();
    },

    // HUB-8xxx: history tab — backed by GET /ntcmappingmaster/history.
    // uploadedBy is optional; limit + offset are required by the BE Joi
    // validator, so send them on every call.
    getFileHistory() {
      this.isLoadingHistory = true;
      const params = {
        limit:  this.historyLimit,
        offset: this.historyPageno * this.historyLimit,
      };
      const uploadedBy = (this.historyFilter.uploadedBy || "").trim();
      if (uploadedBy) params.uploadedBy = uploadedBy;

      axios
        .get(apiUrl.api_url_hubops + "ntcmappingmaster/history", {
          params,
          headers: { Authorization: "authkey xB84JJ89Hd25" },
        })
        .then(
          (res) => {
            this.isLoadingHistory = false;
            if (res.data.ResultCode == 100) {
              this.historyRows      = res.data.ResponseData || [];
              const pg              = res.data.pagination || {};
              this.historyTotalRows = pg.totalCount || this.historyRows.length;
              this.historyPageCount = pg.totalPages || 0;
            } else if (res.data.ResultCode == 101) {
              this.historyRows      = [];
              this.historyTotalRows = 0;
              this.historyPageCount = 0;
            } else {
              this.$alertify.error(res.data.ReturnMessage);
            }
          },
          (err) => {
            console.error(err);
            this.isLoadingHistory = false;
            this.$alertify.error("Error Occured");
          },
        );
    },

    applyHistoryFilters() {
      this.historyPageno = 0;
      this.getFileHistory();
    },

    resetHistoryFilters() {
      this.historyFilter.uploadedBy = "";
      this.historyPageno = 0;
      this.getFileHistory();
    },

    getHistoryPagination(pageNum) {
      this.historyPageno = pageNum - 1;
      this.getFileHistory();
    },

    // HUB-8xxx: open the per-file audit trail modal. Resets pagination so
    // switching between files always starts at page 1.
    openAuditModal(row) {
      if (!row || !row.id) {
        this.$alertify.error("Missing file id for audit history.");
        return;
      }
      this.auditFileId    = row.id;
      this.auditFileName  = row.filename || "";
      this.auditRows      = [];
      this.auditPageno    = 0;
      this.auditTotalRows = 0;
      this.auditPageCount = 0;
      this.isAuditModalShow = true;
      this.getAuditHistory();
    },

    // HUB-8xxx: paginated GET /ntcmappingmaster/auditHistory. limit + offset
    // are always sent. fileId is optional: when set (per-file modal flow) the
    // BE scopes the trail to that file; when omitted (History tab flow) the
    // BE returns the global audit trail.
    getAuditHistory() {
      this.isLoadingAudit = true;
      const params = {
        scanlocationhubid: this.hubId,
        limit:  this.auditLimit,
        offset: this.auditPageno * this.auditLimit,
      };
      if (this.auditFileId) params.fileId = this.auditFileId;

      axios
        .get(apiUrl.api_url_hubops + "ntcmappingmaster/auditHistory", {
          params,
          headers: { Authorization: "authkey xB84JJ89Hd25" },
        })
        .then(
          (res) => {
            this.isLoadingAudit = false;
            if (res.data.ResultCode == 100) {
              this.auditRows      = res.data.ResponseData || [];
              const pg            = res.data.pagination || {};
              this.auditTotalRows = pg.totalCount || this.auditRows.length;
              this.auditPageCount = pg.totalPages || 0;
            } else if (res.data.ResultCode == 101) {
              this.auditRows      = [];
              this.auditTotalRows = 0;
              this.auditPageCount = 0;
            } else {
              this.$alertify.error(res.data.ReturnMessage);
            }
          },
          (err) => {
            console.error(err);
            this.isLoadingAudit = false;
            this.$alertify.error("Error Occured");
          },
        );
    },

    getAuditPagination(pageNum) {
      this.auditPageno = pageNum - 1;
      this.getAuditHistory();
    },

    closeAuditModal() {
      this.isAuditModalShow = false;
      this.auditRows      = [];
      this.auditFileId    = null;
      this.auditFileName  = "";
      this.auditPageno    = 0;
      this.auditTotalRows = 0;
      this.auditPageCount = 0;
    },

    // HUB-8xxx: format the tri-state audit boolean (true / false / null) so
    // the modal never renders a jarring "null" string for legacy rows where
    // the column didn't apply.
    formatAuditBool(value) {
      if (value === null || value === undefined) return "--";
      return value ? "Active" : "Inactive";
    },


    // HUB-8xxx: hydrate the modal from the search-row response. New API
    // fields (ntcHubName / secondaryNtcHubName / destinationHubName) are
    // preferred; legacy snake_case is kept as a fallback for pre-migration
    // rows. `editOriginal` snapshots the initial values so submitEdit can
    // send only fields the operator actually changed.
    openEditRow(row) {
      const destination  = row.destinationHubName  || row.bag_destination || row.destination || "";
      const ntc          = row.ntcHubName          || row.ntc             || "";
      const secondaryNtc = row.secondaryNtcHubName || "";

      this.editForm = {
        id:           row.id,
        bagOrigin:    row.bagOriginHubName    || row.bag_origin    || row.bagOrigin    || "",
        scanLocation: row.scanLocationHubName || row.scan_location || row.scanLocation || "",
        routeMode:    row.routeMode           || row.route         || "",
        destination,
        ntc,
        secondaryNtc,
        isActive:     row.is_active !== undefined ? !!row.is_active : !!row.isActive,
      };
      this.editOriginal = { destination, ntc, secondaryNtc };
      EDITABLE_SELECT_FIELDS.forEach((f) => {
        this.editItems[f] = this.matchHubOption(this.editForm[f]);
      });
      this.isEditModalShow = true;
    },

    closeEditModal() {
      this.isEditModalShow = false;
      this.editForm = {
        id: null,
        bagOrigin: "",
        scanLocation: "",
        routeMode: "",
        destination: "",
        ntc: "",
        secondaryNtc: "",
        isActive: true,
      };
      this.editOriginal = { destination: "", ntc: "", secondaryNtc: "" };
      EDITABLE_SELECT_FIELDS.forEach((f) => {
        this.editItems[f] = { value: "", text: "" };
      });
    },

    // HUB-8xxx: clear Secondary NTC from the Edit modal — leaves the form
    // in a state where submitEdit will send `secondaryNtc: ""` (BE contract
    // to clear the value on the underlying route).
    clearEditSecondaryNtc() {
      this.editItems.secondaryNtc = { value: "", text: "" };
      this.editForm.secondaryNtc  = "";
    },

    submitEdit() {
      if (!this.editForm.id) {
        this.$alertify.error("Missing row id for edit.");
        return;
      }

      // HUB-8xxx: block Secondary NTC == Primary NTC before hitting the wire.
      // "Effective" Primary NTC after edit is whatever is currently in the
      // form (pre-populated to the row's current NTC, may have been changed).
      if (
        this.editForm.secondaryNtc &&
        this.editForm.secondaryNtc === this.editForm.ntc
      ) {
        this.$alertify.error("Secondary NTC cannot be the same hub as NTC.");
        return;
      }

      this.isSavingEdit = true;
      // Always send isActive (boolean toggle). Only include NTC / Destination
      // / Secondary NTC when the operator changed them vs. the row's original
      // value — matches the BE upsert semantics and avoids spurious writes.
      const payload = {
        id:           Number(this.editForm.id),
        isActive:     !!this.editForm.isActive,
        modifiedBy:   this.createdBy,
        currentHubId: this.hubId,
      };
      EDITABLE_SELECT_FIELDS.forEach((f) => {
        if (this.editForm[f] !== this.editOriginal[f]) {
          payload[f] = this.editForm[f];
        }
      });

      axios
        .post(apiUrl.api_url_hubops + "ntcmappingmaster/editRow", payload, {
          headers: { Authorization: "authkey xB84JJ89Hd25" },
        })
        .then(
          (res) => {
            this.isSavingEdit = false;
            if (res.data.ResultCode == 100) {
              // HUB-8xxx: BE returns "No changes to update." as a benign
              // success — close the modal silently in that case, otherwise
              // surface the confirmation.
              const msg = res.data.ReturnMessage || "";
              if (!/no changes to update/i.test(msg)) {
                this.$alertify.success(msg || "Mapping updated.");
              }
              this.closeEditModal();
              this.searchMappings();
            } else {
              this.$alertify.error(res.data.ReturnMessage);
            }
          },
          (err) => {
            console.error(err);
            this.isSavingEdit = false;
            this.$alertify.error("Error Occured");
          },
        );
    },

    // Build a .csv with header + a couple of example rows so operators can
    // see the expected layout. HUB-8xxx: Secondary NTC column is optional —
    // one sample row demonstrates a value, one leaves it blank.
    downloadSampleCsv() {
      const csvFields = this.ntcColumns.reduce((acc, c) => {
        acc[c.key] = c.header;
        return acc;
      }, {});
      const sampleData = [
        {
          scan_location: "DEL/HUB",
          bag_origin: "ALL",
          bag_destination_id: 72,
          bag_destination: "BOM/HUB",
          route: "Surface",
          ntc: "DEL/PTD",
          secondary_ntc: "GGN",
        },
        {
          scan_location: "DEL/HUB",
          bag_origin: "PNQ/BAN",
          bag_destination_id: 228,
          bag_destination: "ALIGARH",
          route: "Air",
          ntc: "BOM/HUB",
          secondary_ntc: "",
        },
      ];
      this.jsonToCSV("ntc_mapping_master_sample.csv", sampleData, csvFields);
    },

    uploadConfigFile(event) {
      this.failed = [];
      this.lastUploadSummary = null;
      this.selectedFile = event.target[0].elements[0].files[0];

      if (!this.selectedFile) {
        this.$alertify.error("Please select a file to upload.");
        return false;
      }

      if (this.selectedFile.size > 5242880) {
        this.$alertify.error(
          "Failed! Upload Max File Size Should Not Be Greater Than 5 MB",
        );
        return false;
      }

      if (!/\.(csv)$/i.test(this.selectedFile.name) &&
          !/\.(zip)$/i.test(this.selectedFile.name)) {
        this.isLoadingUpload = false;
        this.$alertify.error(
          "Failed! Please Upload Only Valid Format: .csv or .zip",
        );
        return false;
      }

      this.isLoadingUpload = true;

      const fd = new FormData();
      fd.append("currentHubId", this.hubId);
      fd.append("uploadedBy", this.createdBy);
      fd.append("fileData", this.selectedFile);
      fd.append("fileName", this.selectedFile.name);

      axios
        .post(apiUrl.api_url_hubops + "ntcmappingmaster/upload", fd, {
          headers: {
            Authorization: "authkey xB84JJ89Hd25",
          },
        })
        .then(
          (result) => {
            if (result.data.ResultCode == 100) {
              // HUB-8xxx: BE upsert now returns insertedCount + updatedCount
              // in ResponseData. Surface the split in the success toast and
              // keep a summary block visible under the upload form.
              const data = result.data.ResponseData || {};
              this.lastUploadSummary = {
                totalRows:     data.totalRows     != null ? data.totalRows     : null,
                validCount:    data.validCount    != null ? data.validCount    : null,
                insertedCount: data.insertedCount != null ? data.insertedCount : null,
                updatedCount:  data.updatedCount  != null ? data.updatedCount  : null,
              };

              const parts = [];
              if (this.lastUploadSummary.insertedCount != null) {
                parts.push(`${this.lastUploadSummary.insertedCount} new mappings inserted`);
              }
              if (this.lastUploadSummary.updatedCount != null) {
                parts.push(`${this.lastUploadSummary.updatedCount} existing mappings updated`);
              }
              const toast = parts.length
                ? `Upload complete: ${parts.join(", ")}.`
                : (result.data.ReturnMessage || "Upload complete.");
              this.$alertify.success(toast);
              this.resetForm(null, true);
            } else {
              this.$alertify.error(result.data.ReturnMessage);
            }

            if (
              result &&
              result.data.failed &&
              result.data.failed.length > 0
            ) {
              this.failed = result.data.failed;
            }

            this.isLoadingUpload = false;
          },
          (error) => {
            console.error(error);
            this.isLoadingUpload = false;
            this.$alertify.error("Error Occured");
          },
        );
    },

    onUploadSubmit: function () {
      this.$validator
        .validateAll()
        .then((result) => {
          if (result) {
            this.uploadConfigFile(event);
            event.target.reset();
          }
        })
        .catch(() => {
          this.$alertify.error("Error Occured");
        });
    },

    // Export server-reported failed rows back to the operator as .csv so they
    // can fix and re-upload. Backend rows are expected to carry the display
    // header keys (see NTC_MAPPING_COLUMNS) plus a "Reason" column.
    exportFailedConfig() {
      if (!this.failed || this.failed.length === 0) {
        this.$alertify.error("No failed rows to export.");
        return;
      }
      this.isLoadingUpload = true;

      const csvFields = this.ntcColumns.reduce((acc, c) => {
        acc[c.header] = c.header;
        return acc;
      }, {});
      csvFields.Reason = "Reason";

      this.jsonToCSV("ntc_mapping_master_failed.csv", this.failed, csvFields);
      this.isLoadingUpload = false;
    },

    jsonToCSV(filename, data, csvfield, skipFilter = []) {
      let csvData = "";
      const fieldKeys = Object.keys(csvfield).filter(
        (key) => skipFilter.indexOf(key) === -1,
      );
      csvData += fieldKeys.map((key) => csvfield[key]).join(",") + "\r\n";
      data.forEach(function (item) {
        csvData += fieldKeys
          .map((key) => {
            let value = item[key];
            if (value === null || value === undefined) return "";
            let escapedCSV = value + "";
            if (escapedCSV.match(/[,"\n]/)) {
              escapedCSV = '"' + escapedCSV.replace(/\"/g, '""') + '"';
            }
            if (escapedCSV == "null") return "";
            return escapedCSV;
          })
          .join(",");
        csvData += "\r\n";
      });
      return this.export(csvData, filename, "application/csv");
    },

    export(data, filename, mime) {
      const blob = this.base64ToBlob(data, mime);
      download(blob, filename, mime);
    },

    base64ToBlob(data, mime) {
      const base64 = window.btoa(window.unescape(encodeURIComponent(data)));
      const bstr = atob(base64);
      let n = bstr.length;
      const u8arr = new Uint8ClampedArray(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: mime });
    },

    resetForm(event, preserveSummary = false) {
      this.isLoadingUpload = false;
      this.failed = [];
      this.selectedFile = null;
      if (!preserveSummary) this.lastUploadSummary = null;
      this.$validator.reset();
      this.errors.clear();
      if (event && event.target && event.target.form) {
        event.target.form.reset();
      }
    },

    // HUB-8xxx: colourize new audit action labels so the History tab is
    // scannable at a glance. Falls back to a neutral badge for anything
    // unrecognised (forward-compatible with new BE actions).
    auditActionBadgeClass(action) {
      const key = (action || "").toLowerCase();
      if (key === "uploaded")                return "action-badge action-uploaded";
      if (key === "inserted")                return "action-badge action-inserted";
      if (key === "secondary ntc added")     return "action-badge action-secondary-added";
      if (key === "secondary ntc changed")   return "action-badge action-secondary-changed";
      if (key === "secondary ntc cleared")   return "action-badge action-secondary-cleared";
      if (key === "ntc changed")             return "action-badge action-ntc-changed";
      if (key === "destination changed")     return "action-badge action-destination-changed";
      if (key === "active changed")          return "action-badge action-active-changed";
      if (key === "edited")                  return "action-badge action-edited";
      return "action-badge";
    },
  },
};



// WEBPACK FOOTER //
// ./src/views/components/NtcMappingMaster/NtcMappingMaster.js